import { getCorrectExpDate } from '../../../../functions/agent/date/getCorrectExpDateForScaning'
import getAgentStatuses from '../../../../functions/agent/documents/getAgentStatuses'
import { getCorrectGender, getCountryCodes } from '../../../../functions/getDataForSelects/getCountries'
import { documentTypes, USER_ID_BACK_ID_LOAD, USER_ID_FRONT_ID_KEY } from '../../../../urls'
import { setStatuses } from '../../../slices/agentSlice'
import { authSlice } from '../../../slices/authSlice'
import { documentsSlice, setMaxAttemptsScan } from '../../../slices/documentSlice'
import { dataFetchingFinish, dataFetchingStart } from '../../../slices/modalSlice'
import { type User } from '../../../slices/userSlice'
import { store, type AppDispatch, type RootState } from '../../../store'

import { archiveDocument } from '../archiveDocument'
import { checkDocument } from '../checkDocument'
import { scanDocument } from '../scaning/documentScan'
import { getErrorss, getMessageForError } from '../../../../functions/errors/GetErrors'
import getUserType from '../../../../functions/shared/user/getUserType'
import { setCreatePropertyFields } from '../../../slices/propertySlice'
import { checkDocForProbabilityAgentName } from '../../../../functions/agent/documents/checkDocForProbabilityAgentName'
import { uploadFiles } from './uploadFiles'
import { checkUserDocumentIfItUseOtherUser } from '../checkUserDocumentIfItUseOtherUser'
import { mainSwalDeal } from '../../../../functions/swalOptions'

export const uploadFile = (formValues: Record<string, any>) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
        dispatch(authSlice.actions.authFetching(true))
        dispatch(dataFetchingStart())

        let checkFile =  null
        if ('visa' in formValues) {
            checkFile = formValues?.visa?.[0] 
        } if('rera' in formValues){
            checkFile = formValues?.rera?.[0] 
        } if('id_front' in formValues){
            checkFile = formValues?.id_front?.[0] 
        } if ('id_back' in formValues){
            checkFile = formValues?.id_back?.[0] 
        }
        const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif' , "application/pdf"]; 
        const validDocSize = 20000000
        if (checkFile?.size > validDocSize) {
            dispatch(dataFetchingFinish())
            return { isSuccessful: false, textNotification: getErrorss(getMessageForError("File is too large") ) }
        } if (!validImageTypes.includes(checkFile?.type)) {
            dispatch(dataFetchingFinish())
            return { isSuccessful: false, textNotification: getErrorss(getMessageForError("It's wrong format type") ) }
        }     

        const maxAttemptsScan  = getState().documents.maxAttemptsScan
        const currentUser = getState().user.currentUser as User
        const docsAgent = getState().documents?.documents.filter((doc) => doc.attributes.User.data?.id === currentUser.id)
        const usDateB = currentUser?.ContactInfo?.DateOfBirth
        const fileTypesToUpload = []
        const scanDoc = await dispatch(scanDocument(formValues))
        formValues.ForRegister = true 
        if ('visa' in formValues) {
            fileTypesToUpload.push('visa')
            if (scanDoc != null) {
                const scanDocument = scanDoc?.document
                if (scanDoc?.type !== 'Passport') {
                    dispatch(dataFetchingFinish())
                    return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: `Only ${formValues?.type_document_page.includes('passport') ? 'Passport' : 'Emirates ID'} is loaded in this section, please select the correct document type.` }
                } else {
                    if ("valid" in scanDocument && scanDocument?.valid) {
                        formValues.visa_expiry = getCorrectExpDate(scanDocument?.expDate ?? '')
                        formValues.dob = scanDocument?.dob ? getCorrectExpDate(scanDocument?.dob) : ""
                        if (scanDocument?.gender) {
                            formValues.gender = getCorrectGender(scanDocument.gender);
                        }
                        if (scanDocument?.nationality ) {
                            formValues.nationality =  getCountryCodes(scanDocument?.nationality)
                        }
                        
                   
                        formValues.name = scanDocument?.name ?? ''
                        formValues.number = scanDocument?.number ?? ''
                        formValues.status = scanDocument?.valid as boolean ? 'Approved' : 'In-process'
                    
                        const checkDoc = await checkDocument(formValues, fileTypesToUpload)
          
                        if (checkDoc) {
                            dispatch(dataFetchingFinish())
                            return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: 'This document is used by the other user' }
                        }
                        const useOtherAgent = await checkUserDocumentIfItUseOtherUser(formValues)
                        if(useOtherAgent){
                            dispatch(dataFetchingFinish())
                            formValues.status = 'In-process'
                            formValues.textNotification = 'Your document was not recognized perfectly, Within 24 hours we will confirm your documents and you will be able to use the corresponding functionality'
                        } else {
                            if (formValues.isLoadedDocumentFromSettings) {
                                const probability = checkDocForProbabilityAgentName(scanDoc?.document?.name)
                                if (probability >= 55  && usDateB === formValues.dob) {
                                    formValues.status = 'Approved'
                                } else {
                                    formValues.status = 'In-process'
                                    formValues.textNotification = 'Your document was not recognized perfectly, Within 24 hours we will confirm your documents and you will be able to use the corresponding functionality'
                                }
                            }
                        }
                    } else {
                        dispatch(dataFetchingFinish())
                        return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: 'Your Passport cannot be recognized.\nPlease try again' }
                    }
                }
            } else {
                if(maxAttemptsScan > 2){
                    formValues.status = 'In-process'
                    formValues.textNotification = "We encountered several unsuccessful attempts during the scanning process. Our team will <strong>manually review</strong> this document within <strong>the next 24 hours</strong>. However, <strong>some functionality</strong> within the app <strong>will be limited</strong> during this time.\nIf you <strong>agree</strong>, please click <strong>\"Request Manual Review.\"</strong> You can <strong>also update</strong> the document at <strong>any time</strong> and try again by going to <strong>\"Settings\"</strong> in your profile, or you can choose <strong>to retry now</strong>."
                    formValues.maxAttemptsWarning = true           
                  
                } else {
                    dispatch(dataFetchingFinish())
                    dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                    return { textNavigate: '', isSuccessful: false, textNotification: 'Your Passport cannot be recognized.\nPlease try again' }
                }
               
            }
        }
      
        
        if ('rera' in formValues) {

            if (scanDoc !== null) {
                fileTypesToUpload.push('rera')
                // if (scanDoc !== null) {
                    
                formValues.rera_expiry = getCorrectExpDate(scanDoc?.document?.expDate ?? '')
                formValues.number = scanDoc?.document?.number ?? ''
                formValues.status = scanDoc?.document?.valid ? 'Approved' : 'In-process'
                formValues.name = scanDoc?.document?.name ?? ''
                formValues.companyName = scanDoc?.document?.companyName ?? ''
                formValues.rera_issue = getCorrectExpDate(scanDoc?.document?.issueDate ?? '')

            
        

                const checkDoc = await checkDocument(formValues, fileTypesToUpload)
                if (checkDoc) {
                    dispatch(dataFetchingFinish())
                    return { textNavigate: '', isSuccessful: false, textNotification: 'RERA is used by another user' }
                }
                if(maxAttemptsScan > 2){
                    await mainSwalDeal('Your RERA card cannot be matched with your name. You can upload it for a <strong>manually review</strong> by the BSO manager or try scanning again.',
                        "Attention!",  'Yes, upload' , 'Try again').then(async (result: any) => { // : 'Request Manual Review'
                        if (result.isConfirmed) {
                            formValues.status = 'In-process'
                            formValues.textNavigate =  formValues?.redirect || ''
                            formValues.textNotification = 'Within 24 hours we will confirm your documents and you will be able to use the corresponding functionality'
                        } if (result.isDenied) {
                            dispatch(setMaxAttemptsScan(maxAttemptsScan +  1))
                            dispatch(dataFetchingFinish())
                            return { textNavigate:  '', isSuccessful: false, textNotification: ""  }
                        }
                    });
                } else {
                    const probability = checkDocForProbabilityAgentName(scanDoc?.document?.name)
                    if (probability < 55 && usDateB !== formValues.dob) {
                        dispatch(setMaxAttemptsScan(maxAttemptsScan +  1))
                        dispatch(dataFetchingFinish())
                        return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: 'This RERA card doesn\'t match.' }
                    } 
                }



            } else {
                dispatch(dataFetchingFinish())
                dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                return { textNavigate:  '', isSuccessful: false ,  textNotification: 'Your RERA card cannot be recognized.\nPlease try again' }
                
            }
        }
        if ('id_front' in formValues) {
            fileTypesToUpload.push('id_front')
     
            if (scanDoc !== null) {
                const scanDocument = scanDoc?.document
                if (!(scanDoc?.type === 'Emirates ID' || scanDoc?.type === 'Emirates ID Front')) {
                    dispatch(dataFetchingFinish())
                    return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: `Only ${formValues?.type_document_page.includes('emirates') ? 'Emirates ID' : 'Passport'} is loaded in this section, please select the correct document type.` }
                } else {
                    formValues.dob = scanDocument?.dob ? getCorrectExpDate(scanDocument?.dob) : ""
                    formValues.name = scanDocument.name ?? ''
                    formValues.number = scanDocument.number ?? ''
                    formValues.status = scanDocument.valid as boolean ? 'Approved' : 'In-process'
                    if (scanDocument?.gender) {
                        formValues.gender = getCorrectGender(scanDocument.gender);
                    }
                    if (scanDoc?.document?.nationality) {
                        formValues.nationality =   getCountryCodes(scanDoc?.document?.nationality)
                    }
                    const checkDoc = await checkDocument(formValues, fileTypesToUpload)
            
                    if (checkDoc === true) {
                        dispatch(dataFetchingFinish())
                        return { textNavigate: '', isSuccessful: false, textNotification: 'This document is used by the other user'  }
                    }
                    const useOtherAgent = await checkUserDocumentIfItUseOtherUser(formValues)
                    if(useOtherAgent === true){
                        dispatch(dataFetchingFinish())
                        return { textNavigate: '', isSuccessful: false, textNotification: 'There is already an account using documents with this name' }
                    } else {
                        if (formValues.isLoadedDocumentFromSettings) {
                            const probability = checkDocForProbabilityAgentName(scanDoc?.document?.name)
                            if ((probability < 55  && usDateB === formValues.dob)) {   
                                if(maxAttemptsScan > 2){
                                    await mainSwalDeal('Your Emirates ID cannot be matched with your name. You can upload the current with Emirates ID Back Side for a <strong>manually review</strong> by the BSO manager or try scanning again.',
                                        "Attention!",  'Yes, upload and go to back side' , 'Try again').then(async (result: any) => { // : 'Request Manual Review'
                                        if (result.isConfirmed) {
                                            formValues.textNavigate =  formValues?.redirect || ''
                                        } if (result.isDenied) {
                                            dispatch(setMaxAttemptsScan(maxAttemptsScan +  1))
                                            dispatch(dataFetchingFinish())
                                            return { textNavigate:  '', isSuccessful: false, textNotification: ""  }
                                        }
                                    });
                                } else {
                                    dispatch(dataFetchingFinish())
                                    dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                                    //  return { textNavigate:  '', isSuccessful: false, textNotification: 'Your Emirates ID cannot be matched with your name.\nPlease try again' }
                                }
                            }
                        }
                    }
                }
            } else {
                if(maxAttemptsScan > 2){
                    await mainSwalDeal('Upload Emirates ID Back Side for fulled document to a <strong>manually review</strong> by the BSO manager.',
                        "Attention!", ' Request Manual Review', 'Try again').then(async (result: any) => {
                        if (result.isConfirmed) {
                            formValues.status = 'In-process'
                            formValues.textNotification = 'The scanned text is unclear. You can upload the current with Emirates ID Back Side for a <strong>manually review</strong> by the BSO manager or try scanning again.' 
                            formValues.maxAttemptsWarning = true   
                        } if (result.isDenied) {
                            dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                            dispatch(dataFetchingFinish())
                        }
                    });
                } else {
                    dispatch(dataFetchingFinish())
                    dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                    return { textNavigate: '', isSuccessful: false, textNotification: 'Your Emirates ID cannot be recognized.\nPlease try again' }
                } 
            }
        }
        if ('id_back' in formValues) {
      
            fileTypesToUpload.push('id_back')
            if (scanDoc !== null) {
                if (scanDoc?.type !== 'Emirates ID') {
                    dispatch(dataFetchingFinish())
                    return { 
                        textNavigate: formValues?.redirect || '', 
                        isSuccessful: false, 
                        textNotification: `Only ${formValues?.type_document_page.includes('emirates') ? 'Emirates ID' : 'Passport'} is loaded in this section, please select the correct document type.` 
                    }
                } else {                  
                    if ( 'valid' in  scanDoc?.document && scanDoc?.document?.valid) {
                        formValues.id_back_expiry = getCorrectExpDate(scanDoc?.document?.expDate ?? '') ?? ''
                        formValues.dob = getCorrectExpDate(scanDoc?.document?.dob ?? '') ?? ''
                        formValues.name = scanDoc?.document?.name ?? ''
                        formValues.number = scanDoc?.document?.number ?? ''
                        formValues.status = scanDoc?.document?.valid ? 'Approved' : 'In-process'
                        if (scanDoc?.document?.gender) {
                            formValues.gender =  getCorrectGender(scanDoc?.document?.gender)
                        }
                        if (scanDoc?.document?.nationality) {
                            formValues.nationality =   getCountryCodes(scanDoc?.document?.nationality)
                        }

                        const checkDoc = await checkDocument(formValues, fileTypesToUpload)
                        if (checkDoc) {
                            dispatch(dataFetchingFinish())
                            return { textNavigate: formValues?.redirect || '', isSuccessful: false, textNotification: 'This document is used by the other user' }
                        }

                        const useOtherAgent = await checkUserDocumentIfItUseOtherUser(formValues)
                        if(useOtherAgent){
                            dispatch(dataFetchingFinish())
                            return { textNavigate: '', isSuccessful: false, textNotification: 'There is already an account using documents with this name' }
                        } else {
                            if (formValues.isLoadedDocumentFromSettings) {
                                const probability = checkDocForProbabilityAgentName(scanDoc?.document?.name)
                                if(maxAttemptsScan > 2){
                                    formValues.status = 'In-process'
                                    formValues.textNotification = 'Within 24 hours we will confirm your documents and you will be able to use the corresponding functionality'
                                } else {
                                    if (probability < 55 && usDateB === formValues.dob) {// 
                                        dispatch(dataFetchingFinish())
                                        dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                                        return { textNavigate: formValues?.redirect || '', isSuccessful: false, maxAttemptsWarning : true  , textNotification: 'The scanned text is unclear. You can upload the current with Emirates ID Back Side for a <strong>manually review</strong> by the BSO manager or try scanning again.' }
                                    } else {
                                        dispatch(setMaxAttemptsScan(0))
                                        formValues.textNotification = 'Your Emirates ID has been successfully uploaded and approved'
                                    }
                                }
                            }
                        }
                    } else {
                        dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                        dispatch(dataFetchingFinish())
                        return { textNavigate: '', isSuccessful: false, textNotification: 'Your Emirates ID cannot be recognized.\nPlease try again' }
                    }
                }
            } else {    

                if(maxAttemptsScan > 2){
                    formValues.status = 'In-process'
                    formValues.textNotification = " Our team will <strong>manually review</strong> this document within <strong>the next 24 hours</strong>. However, <strong>some functionality</strong> within the app <strong>will be limited</strong> during this time.</strong> You can <strong>also update</strong> the document at <strong>any time</strong> and try again by going to <strong>\"Settings\"</strong> in your profile."          
             
                } else {
                    dispatch(dataFetchingFinish())
                    dispatch(setMaxAttemptsScan(maxAttemptsScan + 1))
                    return { textNavigate: '', isSuccessful: false, textNotification: 'Your Emirates ID cannot be recognized.\nPlease try again' }
                }
            }
        }
      

        for (const fileType of fileTypesToUpload) {
            const doc: any = docsAgent.find((doc: any) => {
                return doc?.attributes?.Type?.[0]?.__component === documentTypes[fileType] && !doc?.attributes?.Statuses?.includes('Archived')
            })

            if (doc) {
                if (fileType === 'rera' || fileType === 'visa') {
                    const archDoc = await archiveDocument(doc.id)
                    if (archDoc.success) {
                        if (!(archDoc?.response?.error != null)) {
                            dispatch(documentsSlice.actions.documentUpdateArchive(archDoc?.response?.data))
                        }
                    }
                } else {
                    if (fileType === 'id_back') {
                        if (doc?.attributes?.LinkBack !== null && doc?.attributes?.LinkFront !== null) {
                            const archDoc = await archiveDocument(doc.id)
                            if (archDoc.success) {
                                if (!(archDoc?.response?.error != null)) {
                                    dispatch(documentsSlice.actions.documentUpdateArchive(archDoc?.response?.data))
                                }
                            }
                        }
                    }
                }
            }
        }
      
        const result = await uploadFiles(formValues, fileTypesToUpload)
 
        const filteredResults = result.filter((item: any) => item?.success && item?.response && item?.response?.data && item?.response?.data?.attributes)
       
        if (filteredResults.length > 0) {
            dispatch(documentsSlice.actions.documentAddSuccess(filteredResults[0]?.response?.data))
            if(filteredResults[0]?.response?.data.attributes?.LinkBack && filteredResults[0]?.response?.data.attributes?.LinkFront){
                window.localStorage.removeItem(USER_ID_BACK_ID_LOAD)
                window.localStorage.removeItem(USER_ID_FRONT_ID_KEY)
            }
            const docsM = store.getState().documents.documents
            dispatch(setStatuses(getAgentStatuses(docsM)))
            

            dispatch(dataFetchingFinish())
            dispatch(authSlice.actions.authFetching(false))
            return { scanDoc, textNavigate:  formValues?.redirect || '/agent/settings', isSuccessful: true, textNotification: formValues.textNotification ?? '' ,   maxAttemptsWarning : formValues?.maxAttemptsWarning  }
        } else {
            dispatch(dataFetchingFinish())
            dispatch(authSlice.actions.authFetching(false))
            return {  textNavigate:  '', isSuccessful: false, textNotification: getErrorss(getMessageForError("Something wrong.Please try again")) }
        }
    } catch (error) {
        console.log(error, 'error1')
        dispatch(authSlice.actions.authFetching(false))
        dispatch(dataFetchingFinish())
        return { textNavigate: '', isSuccessful: false, textNotification: 'Error loaded file' }
    }
}